<template>
  <v-card-text>
    <v-row class="mt-6">
      <v-col>
        <PhysicalProgressCard></PhysicalProgressCard>
      </v-col>

      <v-col>
        <FinacialAdvancementCard></FinacialAdvancementCard>
      </v-col>

      <v-col>
        <RHCard></RHCard>
      </v-col>

      <v-col>
        <StockCard></StockCard>
      </v-col>
    </v-row>
    <v-row>
        <v-col>
            <ChartFinancialProgress></ChartFinancialProgress>
        </v-col>
        <v-col>
            <ChartCurveABC></ChartCurveABC>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <ChartPhysicalProgress></ChartPhysicalProgress>
        </v-col>
    </v-row>
    <v-row>
        <v-col>
            <ChartInputControl></ChartInputControl>
        </v-col>
    </v-row>

  </v-card-text>
</template>

<script>

import PhysicalProgressCard from "./_components/PhysicalProgressCard.vue";
import FinacialAdvancementCard from "./_components/FinancialAdvancementCard.vue";
import RHCard from "./_components/RHCard.vue";
import StockCard from "./_components/StockCard.vue";
import ChartCurveABC from "./_components/ChartCurveABC.vue";
import ChartPhysicalProgress from "./_components/ChartPhysicalProgress.vue";
import ChartFinancialProgress from "./_components/ChartFinancialProgress.vue";
import ChartInputControl from "./_components/ChartInputControl.vue";

export default {
  components: {
    PhysicalProgressCard,
    FinacialAdvancementCard,
    RHCard,
    StockCard,
    ChartCurveABC,
    ChartPhysicalProgress,
    ChartFinancialProgress,
    ChartInputControl
  },
  data() {
    return {
      // Example data structure for future use
      physicalProgress: {
        planned: 0,
        actual: 0,
      },
      financialProgress: {
        referenceCost: 0,
        actualCost: 0,
      },
      workforce: {
        baseSalary: 0,
        terminationCost: 0,
      },
      stock: {
        value: 0,
      },
    };
  },
};
</script>

<style scoped>

</style>
